import { useState } from "react";
import { FolderInput, ShoppingBasket, X } from "lucide-react";
import { Button } from "../ui/button";

// Floating bar while ducks are selected: move them (always with their whole family) or basket the print-ready ones.
export const SelectionBar = ({ selected, flocks, onMove, onBasket, onClear, busy }) => {
  const [target, setTarget] = useState("");
  const count = selected.size;
  if (!count) return null;
  const ready = [...selected.values()].filter((c) => c.has_model).map((c) => c.id);
  return (
    <div data-testid="your-ducks-selection-bar" className="fixed inset-x-3 bottom-3 z-40 mx-auto max-w-3xl rounded-2xl border border-border bg-background/85 backdrop-blur-xl shadow-xl p-3 flex flex-wrap items-center gap-2 animate-in fade-in slide-in-from-bottom-4 duration-300">
      <span data-testid="your-ducks-selected-count" className="text-sm font-bold">{count} selected</span>
      <span className="hidden md:inline text-xs text-muted-foreground">Branches always move with their original.</span>
      <div className="flex-1" />
      <select data-testid="your-ducks-move-target" aria-label="Move to flock" value={target} onChange={(e) => setTarget(e.target.value)} className="h-9 rounded-full border border-border bg-card px-3 text-sm max-w-[11rem]">
        <option value="">Move to…</option>
        {flocks.map((f) => (
          <option key={f.id} value={f.id}>{f.name}</option>
        ))}
        <option value="unsorted">Unsorted</option>
      </select>
      <Button size="sm" data-testid="your-ducks-move-btn" disabled={!target || busy} className="rounded-full h-9 gap-1.5 font-bold" onClick={() => onMove(target === "unsorted" ? null : target).then((ok) => ok && setTarget(""))}>
        <FolderInput className="h-4 w-4" /> Move
      </Button>
      {ready.length > 0 && (
        <Button size="sm" variant="outline" data-testid="your-ducks-basket-selected-btn" disabled={busy} className="rounded-full h-9 gap-1.5" onClick={() => onBasket(ready.slice(0, 24))}>
          <ShoppingBasket className="h-4 w-4" /> Basket {Math.min(ready.length, 24)}
        </Button>
      )}
      <Button size="sm" variant="ghost" data-testid="your-ducks-clear-selection" aria-label="Clear selection" className="rounded-full h-9 w-9 p-0" onClick={onClear}>
        <X className="h-4 w-4" />
      </Button>
    </div>
  );
};
